<script>

import PrimaryButton from "../../../../frontend/src/components/ui/PrimaryButton.vue"

export default PrimaryButton
</script>
